import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDealer } from '../../../store/login/action';
import { setupToast } from '../../../store/toast/action';
import { resetUser, setUser, userDeactivation } from '../../../store/user/action';
import MyAccount from './component';

const mapStateToProps = ({ user }) => ({
    user
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setupToastConnect: setupToast,
    resetUserConnect: resetUser,
    userDeactivationConnect: userDeactivation,
    fetchDealerConnect: fetchDealer,
    setUserConnect: setUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);